module.exports = __webpack_public_path__ + "officialStatic/img/solution2.99c581e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solution2.png
// module id = aLVx
// module chunks = 0